// ** Error Messages
export const ErrrorMessage = {
  CREATE: "Created successfully!",
  UPDATE: "Updated successfully.",
  DELETE: "Deleted successfully!",
  Archive: "Archived successfully!",
  DRAFT: "Saved as draft successfully!",
  FeedBackCreate: "Feedback submitted successfully!",
};
